export const ENVIROMENT = {
    DEBUG: "DEBUG",
    DEV: "DEV",
    QA: "QA",
    STAG: "STAG",
    PROD: "PROD",
};
